import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';

import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';

import { BcRecurringModule } from '@bayclubs/recurring';

import { SharedModule } from '@shared/shared.module';

// state
import { CourtEventInfoState } from './+store/court-event-info.state';

// components
import { CourtEventNotesInfoComponent } from './components/court-event-notes-info/court-event-notes-info.component';
import { PlayerInfoComponent } from './components/player-info/player-info.component';

// containers
import { SpinnerModule } from '@bayclubs/spinner';
import { BayclubsUiCoreModule } from '@bayclubs/ui-core';
import { BlockedSlotInfoDetailsComponent } from './containers/blocked-slot-info-details/blocked-slot-info-details.component';
import { CourtBookingInfoDetailsComponent } from './containers/court-booking-info-details/court-booking-info-details.component';
import { CourtClassInfoDetailsComponent } from './containers/court-class-info-details/court-class-info-details.component';
import { PlayerInfoStatusComponent } from './containers/player-info-status/player-info-status.component';

@NgModule({
    declarations: [
        BlockedSlotInfoDetailsComponent,
        CourtBookingInfoDetailsComponent,
        PlayerInfoComponent,
        PlayerInfoStatusComponent,
        CourtClassInfoDetailsComponent,
        CourtEventNotesInfoComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([CourtEventInfoState]),
        NgxsFormPluginModule,
        TranslateModule,
        BcRecurringModule,
        SharedModule,
        SpinnerModule,
        BayclubsUiCoreModule
    ]
})
export class CourtEventInfoModule { }

export * from './services/court-event-info-launcher.service';

